import { VStack, Text, Box, Collapse } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useMfa } from '../../../context/MfaContext';
import MfaEnterCode from './MfaEnterCode';
import { useNavigate } from 'react-router';
import { useMfaToast } from '../../../hooks/useMfaToast';

function MfaSetUpTotp({ onComplete, isModal = null }) {
  const { otpUri, otpSecret, clearMfaSetup } = useMfa();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { showErrorToast } = useMfaToast();

  useEffect(() => {
    if (otpUri) {
      generateQRCode(otpUri);
    } else {
      if (onComplete) {
        onComplete();
      } else {
        setTimeout(() => {
          navigate('/mfa/setup');
          clearMfaSetup();
        }, 3000);
        showErrorToast(
          'Error generating QR code',
          'Redirecting to MFA setup page again...'
        );
      }
    }
  }, [otpUri]);

  const generateQRCode = async (uri) => {
    try {
      // Using qrcode library to generate QR code
      const QRCode = await import('qrcode');
      const dataUrl = await QRCode.toDataURL(uri, {
        width: 256,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      });
      setQrCodeDataUrl(dataUrl);
    } catch (error) {
      console.error('Error generating QR code:', error);
      showErrorToast('Error generating QR code');
    }
  };

  if (!otpUri) {
    return (
      <VStack>
        <Text>Loading QR code...</Text>
      </VStack>
    );
  }

  return (
    <VStack spacing={6} alignItems="flex-start">
      <VStack spacing={4} mb={4} w="full" alignItems="flex-start">
        <VStack spacing={4}>
          <Text textStyle="heading4">
            Use your authenticator app to scan this QR code
          </Text>
          {qrCodeDataUrl && (
            <Box
              p={4}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <img
                src={qrCodeDataUrl}
                alt="TOTP QR Code"
                style={{ maxWidth: '200px', height: 'auto' }}
              />
            </Box>
          )}
          <Text
            textStyle="bodySmall"
            color="brand"
            textAlign="center"
            onClick={() => setIsOpen(!isOpen)}
            cursor="pointer"
            _hover={{
              textDecoration: 'underline',
            }}
          >
            Trouble scanning the QR code?
          </Text>
        </VStack>
        <Collapse in={isOpen} animateOpacity>
          <VStack spacing={4} alignItems="flex-start">
            <Text
              textStyle="bodySmall"
              color="#666666"
              textAlign="center"
              onClick={() => setIsOpen(!isOpen)}
            >
              If you can't scan the QR code, you can manually enter this code in
              your authenticator app:
            </Text>
            <Box
              p={3}
              bg="gray.50"
              borderRadius="md"
              border="1px solid"
              borderColor="gray.200"
              w="full"
              maxW="full"
            >
              <Text
                fontFamily="mono"
                fontSize="sm"
                wordBreak="break-all"
                textAlign="center"
              >
                {otpSecret}
              </Text>
            </Box>
          </VStack>
        </Collapse>
      </VStack>
      <MfaEnterCode onSuccess={onComplete} isModal={isModal} />
    </VStack>
  );
}

export default MfaSetUpTotp;
